// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"718":"cb42c21c","955":"cb42c21c"}[chunkId] + ".chunk.css";
};